import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingSpinner, PersonalInfoCard, PostsInfoCard } from '../components';
import { useUserProfile } from '../hooks/queries/useUser';

const UserProfile = () => {
  const { userId } = useParams();
  const { data: userProfile, isLoading: loading } = useUserProfile(userId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="min-h-screen bg-slate-50/50 pb-20">
      {/* Deep Gradient Cover Header */}
      <div className="relative h-64 sm:h-80 w-full overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-blue-900 to-slate-900">
          {/* Decorative Elements */}
          <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" />
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
          <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-72 h-72 rounded-full bg-blue-500/10 blur-3xl" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          
          {/* Left Column: Personal Info (Sticky) */}
          <div className="lg:col-span-4">
            <div className="bg-white/90 backdrop-blur-xl shadow-xl shadow-slate-200/50 rounded-3xl overflow-hidden border border-white sticky top-28">
              <PersonalInfoCard userInfo={userProfile} />
            </div>
          </div>

          {/* Right Column: Posts Area */}
          <div className="lg:col-span-8">
            <div className="bg-white shadow-xl shadow-slate-200/50 rounded-3xl overflow-hidden min-h-[600px] border border-slate-100">
              <PostsInfoCard userId={userId} />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserProfile;
